module.exports = __webpack_public_path__ + "media/images/lps-pet-aab8eb66.png";